// StoresNotFoundModal.tsx
import React, { useState } from "react";

interface StoresNotFoundModalProps {
  isOpen: boolean;
  stores: any[];
  onYes: () => void;
  onNo: () => void;
  onClose: () => void;
}

const StoresNotFoundModal: React.FC<StoresNotFoundModalProps> = ({
  isOpen,
  stores,
  onYes,
  onNo,
  onClose,
}) => {
  const [closeHover, setCloseHover] = useState(false);
  const [yesHover, setYesHover] = useState(false);
  const [noHover, setNoHover] = useState(false);

  if (!isOpen) return null;

  return (
    <>
      <style>
        {`
          @keyframes modalSlideIn {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <div style={styles.overlay}>
        <div style={styles.container}>
          <div style={styles.header}>
            <h2 style={styles.title}>Stores Not Found</h2>
            <button
              style={{
                ...styles.closeButton,
                ...(closeHover ? styles.closeButtonHover : {}),
              }}
              onClick={onClose}
              onMouseEnter={() => setCloseHover(true)}
              onMouseLeave={() => setCloseHover(false)}
            >
              ✕
            </button>
          </div>

          <div style={styles.content}>
            <div style={styles.warningIcon}>
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M24 4L4 42h40L24 4z" fill="#F59E0B" />
                <path d="M24 16v12M24 32h.02" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
              </svg>
            </div>

            <div>
              <div style={styles.message}>
                <p style={styles.messageText}>
                  The following stores are not part of this chain, to continue project creation with
                  these stores -
                </p>
                <p style={styles.messageText}>
                  you have to create the stores first. Would you like to create the stores now ?
                </p>
              </div>

              <div style={styles.storesList}>
                {stores.map((store, index) => (
                  <span key={index} style={styles.storeBadge}>
                    {store}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div style={styles.footer}>
            <button
              style={{
                ...styles.btnYes,
                ...(yesHover ? { backgroundColor: "#d97706" } : {}),
              }}
              onClick={onYes}
              onMouseEnter={() => setYesHover(true)}
              onMouseLeave={() => setYesHover(false)}
            >
              Yes
            </button>
            <button
              style={{
                ...styles.btnNo,
                ...(noHover ? { backgroundColor: "#f9fafb", borderColor: "#9ca3af" } : {}),
              }}
              onClick={onNo}
              onMouseEnter={() => setNoHover(true)}
              onMouseLeave={() => setNoHover(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoresNotFoundModal;

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(128, 128, 128, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "20px",
  },
  container: {
    background: "white",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "650px",
    boxShadow:
      "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    animation: "modalSlideIn 0.3s ease-out",
    maxHeight: "85vh",
    overflowY: "auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 15px 16px",
    borderBottom: "1px solid #e5e7eb",
  },
  title: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#111827",
    margin: 0,
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "16px",
    color: "#6b7280",
    cursor: "pointer",
    padding: 0,
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "all 0.2s",
  },
  closeButtonHover: {
    backgroundColor: "#f3f4f6",
    color: "#111827",
  },
  content: {
    padding: "20px",
    display: "flex",
    maxHeight: "50vh",
    overflowY: "auto",
  },
  warningIcon: {
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: "16px",
    marginRight: "16px",
  },
  message: {
    marginBottom: "20px",
  },
  messageText: {
    fontSize: "14px",
    color: "#374151",
    lineHeight: 1.6,
    margin: "0 0 8px 0",
  },
  storesList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginTop: "20px",
  },
  storeBadge: {
    display: "inline-block",
    padding: "5px 16px",
    backgroundColor: "#E5B42F",
    color: "#111827",
    fontSize: "14px",
    fontWeight: 500,
    borderRadius: "6px",
    transition: "all 0.2s",
    cursor: "default",
    width: "90px",
    textAlign:"center"
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "16px 24px 24px",
  },
  btnYes: {
    padding: "7px 15px",
    fontSize: "15px",
    fontWeight: 500,
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s",
    backgroundColor: "#E5B42F",
    color: "#111827",
  },
  btnNo: {
    padding: "7px 15px",
    fontSize: "15px",
    fontWeight: 500,
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    cursor: "pointer",
    transition: "all 0.2s",
    backgroundColor: "white",
    color: "#374151",
  },
};
